import { AuthGuard } from "@dis/auth";
import { JtmsRoutes } from "../core/routing/route-data";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "map" },
    children: [
      {
        // Containers is the only layer today; ?layers= comes with the map stub work.
        path: "",
        data: { navOrder: 0, castable: true },
        loadComponent: () =>
          import("../containers/containers-map/containers-map.component").then((m) => m.ContainersMapComponent),
        title: "Map",
      },
    ],
  },
] satisfies JtmsRoutes;
